import { Spin } from 'antd'
import { Suspense } from 'react'
import { RouteObject } from 'react-router-dom'

import { PrivateLayout } from 'src/components/layout'
import * as ROUTES from 'src/constants/routes'
import { NotFound } from 'src/views/notFound'

import { Calendar, Home, Profile, Map, Requests, Friends, Chat, Settings } from './lazyLoad'
import { ProtectedRoute } from './privateRoute'

export const privateRoutes: RouteObject[] = [
  {
    path: ROUTES.PRIVATE_HOME,
    element: (
      <PrivateLayout>
        <ProtectedRoute />
      </PrivateLayout>
    ),
    children: [
      {
        path: ROUTES.PRIVATE_HOME,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_CHAT,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Chat />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_REQUESTS,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Requests />
          </Suspense>
        ),
      },
      {
        path: `${ROUTES.PRIVATE_REQUESTS}/:tab`,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Requests />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_CALENDAR,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Calendar />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_PROFILE,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_MAP,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Map />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_CONNECTIONS,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Friends />
          </Suspense>
        ),
      },
      {
        path: `${ROUTES.PRIVATE_CONNECTIONS}/:tab`,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Friends />
          </Suspense>
        ),
      },
      {
        path: ROUTES.PRIVATE_SETTINGS,
        element: (
          <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>
            <Settings />
          </Suspense>
        ),
      },
      { path: '*', Component: NotFound },
    ],
  },
]
